import { bankData } from 'data/mock-data';

const mock = () => ({
  data: {
    bankData,
  },
});

export default mock;
